import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ProductBanner from '../components/productbanner';
import ProductCards from '../components/productcards';
import Gallery from '../components/gallery';
import Simplecontact from '../components/simplecontact';
import SEO from '../components/SEO';
import { roboticAutomationFeatures, mechanizedautomationFeatures, galleryItems } from './data';
import { Modal } from 'react-bootstrap';

const Products = () => {
  // Schema.org structured data for products page
  const productsSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": "Robomec Automation Products",
    "description": "Industrial automation products including robotic welding systems, thermal cutting systems, and material handling solutions.",
    "url": "https://www.robomecautomation.com/products",
    "itemListElement": [
      {
        "@type": "Product",
        "name": "Robotic Welding Systems",
        "description": "State-of-the-art robotic solutions for precise and efficient welding operations.",
        "image": "https://cdn.statically.io/img/i.postimg.cc/wBJLrjMh/6axis-welding-robots.jpg"
      },
      {
        "@type": "Product",
        "name": "Material Handling Systems",
        "description": "Professional installation of industrial machinery for seamless integration.",
        "image": "https://cdn.statically.io/img/i.postimg.cc/W3DvxXJq/material-handling-robot.jpg"
      },
      {
        "@type": "Product",
        "name": "Girth Welder",
        "description": "High-performance girth welders for seamless circumferential welding.",
        "image": "https://cdn.statically.io/img/i.postimg.cc/d3CbkdVh/automatic-girth-welder-500x500.jpg"
      }
    ]
  };

  // Modal state for product-specific galleries
  const [showModal, setShowModal] = useState(false);
  const [modalItems, setModalItems] = useState([]);
  const [modalTitle, setModalTitle] = useState('');

  const openModal = (items = [], title = '') => {
    setModalItems(items);
    setModalTitle(title);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalItems([]);
    setModalTitle('');
  };

  return (
    <>
      <SEO 
        title="Products & Solutions"
        description="Discover our comprehensive range of industrial automation solutions including robotic welding systems, thermal cutting systems, and material handling solutions."
        canonicalUrl="https://www.robomecautomation.com/products"
        keywords={[
          "industrial automation products",
          "robotic welding systems",
          "thermal cutting systems",
          "material handling solutions",
          "welding rotators",
          "pipe welding systems",
          "positioners and turntables"
        ]}
        schema={productsSchema}
      />
      <Container fluid className="products-container">
        {/* Hero Section */}
        <Row>
          <Col>
            <ProductBanner />
          </Col>
        </Row>

        {/* Robotic Automation Section */}
        <Row>
          <Col>
            <ProductCards
              heading1="Robotic Automation"
              features={roboticAutomationFeatures}
              onFeatureClick={(feature) => {
                const items = (feature.gallery && feature.gallery.length)
                  ? feature.gallery
                  : [ { type: 'image', src: feature.imageSrc, alt: feature.imageAlt } ];
                openModal(items, feature.title);
              }}
            />
          </Col>
        </Row>

        {/* Mechanized Automation Section */}
        <Row>
          <Col>
            <ProductCards
              heading1='Mechanized Automation'
              features={mechanizedautomationFeatures}
              onFeatureClick={(feature) => {
                const items = (feature.gallery && feature.gallery.length)
                  ? feature.gallery
                  : [ { type: 'image', src: feature.imageSrc, alt: feature.imageAlt } ];
                openModal(items, feature.title);
              }}
            />
          </Col>
        </Row>

        {/* Gallery Section */}
        <Row>
          <Col>
            <Gallery
              items = {galleryItems}
            />
          </Col>
        </Row>

        {/* Contact Section */}
        <Row>
          <Col>
            <Simplecontact
              heading1="Contact Us"
              content1="For inquiries or more information about our products and services, please feel free to reach out to us."
            />
          </Col>
        </Row>
      </Container>

      {/* Gallery Modal */}
      <Modal show={showModal} onHide={() => closeModal()} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Gallery items={modalItems} showHeading={false} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Products;
